export default __webpack_public_path__ + "static/media/Q_wdt_c_cap_1.08907aa7.mp3";